<template>
	<v-app dark>
		<v-navigation-drawer permanent fixed app floating primary :dark="true" color="primary" mini-variant-width="56"
			:mini-variant="miniVariant" width="200">
			<v-list-item dense style="height: 64px !important">
				<v-list-item-avatar>
					<v-img src="/images/logo.jpg"></v-img>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title class="text-uppercase font-weight-bold">
						{{ appName }}
					</v-list-item-title>
					<v-list-item-subtitle>
						Version: 1.0.0
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

			<v-list dense nav>
				<Link v-for="(menu, index) in menus" :key="index" :href="menu.url">
				<v-list-item active-class="active-nav-link" :value="menu.group" :input-value="menu.active">
					<v-list-item-action>
						<v-icon>{{ menu.attributes.icon }}</v-icon>
					</v-list-item-action>

					<v-list-item-content>
						<v-list-item-title>{{
						menu.title
						}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				</Link>
			</v-list>
			<template v-slot:append>
				<v-list-item @click="logout()">
					<v-list-item-action>
						<v-icon>mdi-logout</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>Logout</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
		</v-navigation-drawer>
		<v-app-bar fixed app :dark="true" color="primary">
			<v-btn icon @click="toogleMinivariant()">
				<v-icon v-if="!miniVariant">mdi-chevron-left-circle-outline</v-icon>
				<v-icon v-if="miniVariant">mdi-chevron-right-circle-outline</v-icon>
			</v-btn>
			<Link :href="$route('central.index')">
			<v-btn icon exact>
				<v-icon>mdi-home</v-icon>
			</v-btn>
			</Link>
			<v-toolbar-title v-text="appName" />
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<v-btn text :href="$route('index')" target="_blank">
					<v-icon left>mdi-web</v-icon>
					{{ $t("label.frontpage") }}
					<v-icon right>mdi-open-in-new</v-icon>
				</v-btn>
				<v-btn text :href="$route('languages.index')" target="_blank" v-permission:any="'all translation'">
					<v-icon left>mdi-translate</v-icon>
					{{ $t("label.translate") }}
					<v-icon right>mdi-open-in-new</v-icon>
				</v-btn>
				<v-btn text :href="$route('mailableList')" target="_blank">
					<v-icon left>mdi-mail</v-icon>
					{{ $t("label.mail") }}
					<v-icon right>mdi-open-in-new</v-icon>
				</v-btn>
				<v-btn text @click="$inertia.visit($route('central.settings.index'))">
					<v-icon left>mdi-cog</v-icon>
					{{ $t("Setting") }}
				</v-btn>
			</v-toolbar-items>
			<template v-if="user">
				<Link :href="$route('central.profile.index')">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn small text v-on="on">{{ user.name }}</v-btn>
					</template>
					<span>គ្រប់គ្រងគណនី</span>
				</v-tooltip>
				</Link>
			</template>
			<v-badge :content="unreadNotificationsCount" :value="unreadNotificationsCount" color="red" overlap>
				<v-btn icon @click.stop="toggleNotificationDrawer()">
					<v-icon>mdi-bell-ring</v-icon>
				</v-btn>
			</v-badge>
		</v-app-bar>
		<v-main class="indigo lighten-5">
			<v-container fill-height fluid pa-0>
				<v-row class="fill-height flex-nowrap" no-gutters>
					<v-col v-if="submenus.length > 0" cols="auto">
						<v-navigation-drawer :value="submenus.length > 0" width="200px">
							<v-list dense nav>
								<Link :href="submenu.url" v-for="(submenu, index) in submenus"
									:key="'submenu_' + index">
								<v-list-item link :class="{
									'active-nav-link': submenu.active,
								}" :input-value="submenu.active">
									<v-list-item-title v-text="submenu.title"></v-list-item-title>
								</v-list-item>
								</Link>
							</v-list>
						</v-navigation-drawer>
					</v-col>
					<v-col class="flex-shrink-1 flex-grow-1" cols="auto" fluid>
						<app-head :title="$t('Central Dashboard')" />
						<app-flash-message></app-flash-message>
						<slot />
					</v-col>
				</v-row>
			</v-container>
		</v-main>

		<v-navigation-drawer v-model="rightDrawer" right temporary fixed width="400px">
			<app-notification-drawer @onClose="rightDrawer = false" ref="notifications"></app-notification-drawer>
		</v-navigation-drawer>
		<echo></echo>
	</v-app>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
import echo from "./partials/central/echo.vue";

export default {
	components: {
		Link,
		echo,
	},

	data() {
		return {
			clipped: true,
			drawer: true,
			fixed: false,
			miniVariant:
				this.$cookies.get("miniVariant") === "false" ? false : true,
			outlets: [],
			active: null,
			rightDrawer: false,
		};
	},

	computed: {
		appName() {
			return this.$page.props.settings?.general.site_name;
		},

		user() {
			return this.$page.props.auth.user;
		},

		menus() {
			return this.$page.props.navigation;
		},

		submenus() {
			const activeMenu = this.menus.find((menu) => menu.active == true);

			if (activeMenu) {
				return activeMenu.children;
			}

			return [];
		},

		unreadNotificationsCount() {
			return this.$page.props.auth.unreadNotificationsCount;
		},
	},

	methods: {
		logout() {
			this.$inertia.post(this.$route("logout"));
		},

		async toggleNotificationDrawer() {
			this.rightDrawer = !this.rightDrawer;
			if (this.rightDrawer) {
				await this.$refs.notifications.getItems();
			}
		},

		toogleMinivariant() {
			this.miniVariant = !this.miniVariant;
			this.$cookies.set("miniVariant", this.miniVariant);
		},
	},

	mounted() {
		this.$gates.setRoles(this.$page.props.auth.roles);
		this.$gates.setPermissions(this.$page.props.auth.permissions);
	},
};
</script>

<style scoped>
.active-nav-link {
	color: #fff;
	background-color: #c09a49;
	border-color: #c09a49;
}
</style>